/**
 * Configuration globale de l'application Admin.
 * Les variables préfixées par VITE_ sont injectées au build via import.meta.env.
 */

// On récupère la valeur brute (string ou undefined)
const rawEnableRedirect = import.meta.env.VITE_ENABLE_LOGIN_REDIRECT;

export const appConfig = {
  /**
   * Active ou désactive la redirection automatique vers /login
   * lorsque l'utilisateur n'est pas authentifié.
   *
   * @logic
   * - Si la variable est absente (undefined) : true (sécurité par défaut)
   * - Si la variable est "false" (string) : false
   * - Pour toute autre valeur : true
   */
  enableLoginRedirect: rawEnableRedirect === undefined ? true : String(rawEnableRedirect).toLowerCase() !== 'false',

  /**
   * URL de l'API Backend
   */
  apiUrl: import.meta.env.VITE_URL_API || 'http://localhost:3230',
} as const;

// Typage automatique pour l'autocomplétion
export type AppConfig = typeof appConfig;
